<template>
    <div class="container pt-5 pb-5 page">
        <h1 class="mb-5">Een modern beveiligingsbedrijf<br>
        </h1>
        <div class="row mb-5">
            <div class="col-md-6 text-center mt-0 mb-5 mt-md-5">
                <p class="permit sub uppercase m-0 text-muted">vergunning</p>
                <p class="permit uppercase m-0">ND 5590</p>
            </div>
            <div class="col-md-6">
                <h2 class="text-muted uppercase">Het beveiligingsbedrijf van nu!</h2>
                <p>Azurity is een erkend beveiligingsbedrijf die het anders doet dan de traditionele beveiligingsbedrijven. Bij Azurity komen <strong>de professionals op de eerste plek.</strong></p>
                <blockquote class="blockquote">
                    <p class="text-muted text-center">Wij leveren de beste beveiligers, verkeersregelaars, brandwachten en EHBO-ers middels de slimste technologische tools.</p>
                </blockquote>
                <p>Vanuit de eigen kernwaarden van <strong>zelfstandigheid, flexibiliteit en verantwoordelijkheid</strong> willen wij een goede werk-/privé balans creëren voor aangesloten beveiligers, alsmede <strong>flexibiliteit en kwaliteit</strong> borgen voor de opdrachtgevers.</p>
                <p>Wij geloven dat ieder individu prima zelf kan bepalen wat je waard bent en wanneer en waar je wilt en kunt werken. En zo krijgen opdrachtgevers alleen de best gemotiveerde beveiligers.</p> 
            </div>
        </div>
        
        <div class="row mb-5">
            <div class="col-md-6 order-2 order-md-1">
                <h2 class="text-muted uppercase">Het beveiligingsplatform!</h2>
                <p>Middels ons slimme platform faciliteren wij de beveiligingsbranche met slimme tools voor elk besturingssyteem en maken wij onze ambities waar.</p>
                <p>In de huidige markt is het moeilijk goed gekwalificeerd personeel te vinden. Geregeld werken beveiligingsbedrijven, door het gebrek aan voldoende handhaving, niet altijd geheel volgens de <a href="https://wetten.overheid.nl/BWBR0008973/2013-07-04" target="_blank" rel="noreferrer">vigerende wet- en regelgeving</a>. Ons platform geeft op innovatieve wijze een slimme en soepele invulling aan de vigerende wet- en regelgeving en vraag naar gekwalificeerd personeel.</p>
                <p>Enkele voorbeelden waarmee wij het verschil maken:</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Zoek & Boek</p> 
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Rapportages & Reviews</p> 
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Slimme kalender</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Pas-management</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Digitale pas & vergunning aanvragen</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Flexibile tarieven</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon> Snelle administratie</p>
            </div>
            <div class="col-md-6 text-center mt-0 mb-5 mt-md-5 order-1 order-md-2">
                <font-awesome-icon icon="mobile-alt" size="10x" ></font-awesome-icon>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 text-center mt-0 mb-5 mt-md-5 ">
                <font-awesome-icon icon="shield-alt" size="10x" ></font-awesome-icon>
            </div>
            <div class="col-md-6">
                <h2 class="text-muted uppercase">Onze dienstverlening</h2>
                <p>Naas ons innovatieve platform, leveren wij natuurlijk ook gewoon de beste mensen. U kunt bij ons o.a. terecht voor:</p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'objectbeveiliging'}}">Objectbeveiliging</router-link></p> 
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'evenementenbeveiliging'}}">Evenementenbeveiliging</router-link></p> 
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'winkelsurveillance'}}">Winkelsurveillance</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'zorgbeveiliging'}}">Zorgbeveiliging</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'hotelbeveiliging'}}">Hotelbeveiliging</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'museumbeveiliging'}}">Museumbeveiliging</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: {detail: 'receptionisten'}}">Receptionisten</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationTrafficSupport' }">Verkeersregelaars</router-link></p>
                <p class="pl-3 mb-1"><font-awesome-icon icon="check"></font-awesome-icon>&nbsp;<router-link tag="a" :to="{ name: 'InformationFirstAid' }">EHBO-ers</router-link></p>

                <p class="mt-3">Iedere veiligheidsprofessional en opdrachtgever wordt bij ons zorgvuldig gescreened. Zonder de screening kan geen gebruik worden gemaakt van het platform. U kunt er dus gerust vanuit gaan dat al onze beveiligers beschikken over de juiste diploma's, brancheverklaringen en kennis.</p><p> Daarnaast kunnen de opdrachtgever en beveiliger elkaar voor een opdracht reviewen, alsmede door samen te delen middels ons referral programma ontstaat er een zelfsturende controle op <strong>kwaliteit</strong>. Verder houden wij regelmatig kennissessies en faciliteren wij de kennisdeling.</p>
            </div>
        </div>

        <h2>De Naam</h2>
        <p>De naam, Azurity, is een combinatie van 𝘼𝙨𝙨𝙪𝙧𝙖𝙣𝙘𝙚 (zekerheid) en 𝙎𝙚𝙘𝙪𝙧𝙞𝙩𝙮 (veiligheid). Alsmede de heraldische blauwe tint: Azuur. Dat symbool staat voor wetenschap, waarheid, waakzaamheid & dienstbaarheid.</p>
        
        <h2>Contact</h2>
        <p>Voor meer informatie over ons bedrijf, onze kernwaarden en visie, neem volledig vrijblijvend <router-link tag="a" :to="{ name: 'SecurityContact'}" aria-label="Neem contact op met ons.">contact</router-link> met ons op.</p>
        <hr class="mb-5" />
        <register-btns></register-btns>
    </div>
</template>

<script>
import Program from '@/components/Referral/Program';
import RegisterButtons from '@/components/RegisterButtons';
export default {
    components: {
        'register-btns': RegisterButtons,
        'program': Program
    },
}
</script>

<style scoped lang="scss">
.permit {
    font-size: 5rem;
    font-weight: bold;
    line-height: 3.5rem;

    &.sub {
        font-size: 3rem;
    }

    @media only screen and (max-width: 768px) {
        font-size: 4rem;
        &.sub {
            font-size: 2.5rem;
        }
    }
}

</style>